import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";
import { SettingsContext } from "./settings";
import { startTransition, useRef } from "react";
import { useScrollResetOnNavigate } from "../hooks/useScrollResetOnNavigate";

const SettingsProvider = ({ id, className, children }) => {
  const [cookies, setCookie] = useCookies(["theme", "fontSize"]);
  const themeDefault = window.matchMedia("(prefers-color-scheme:dark)").matches
    ? "dark"
    : "light";
  const location = useLocation();
  // Only use theming if the location pathname matches /{locale}/projects/{identifier} or /{locale}/school/project
  const locale = "[a-z]{2}(-[A-Z]{2})?";
  const useTheming = location.pathname.match(
    new RegExp(`/${locale}/projects/[a-z0-9-]+|/${locale}/school/project`),
  );
  const theme = useTheming ? cookies.theme || themeDefault : "light";

  // App.scss gives this element its own overflow, so it scrolls rather than the
  // document.
  const scrollContainerRef = useRef(null);
  useScrollResetOnNavigate(scrollContainerRef);

  document.addEventListener("editor-themeUpdated", (e) => {
    startTransition(() => {
      setCookie("theme", e.detail, { path: "/" });
    });
  });

  return (
    <div
      id={id}
      ref={scrollContainerRef}
      className={[`--${theme}`, className].filter(Boolean).join(" ")}
    >
      <SettingsContext.Provider
        value={{
          theme,
          fontSize: cookies.fontSize || "small",
        }}
      >
        {children}
      </SettingsContext.Provider>
    </div>
  );
};

export default SettingsProvider;
